export const logo_alt = "Logo Infocomp";

export const CURRENCY = "KM";
